export default __webpack_public_path__ + "static/media/information--food--g2.a19e0e4d.png";